<template>
  <div
    class="componentBox"
    @click.self.capture="handleClickSwiperColEv"
    :style="getSwiperBoxStyle"
    draggable="true"
    @drop.stop="handleColsDragover"
    @dragover.prevent
  >
    <vueDragResizable
      ref="vdr"
      v-for="elementOptions in pageContent.elementOptions"
      :key="'layoutComponent' + elementOptions.elementInSwiperId"
      :class="`container_id_${myid.container_id}-rect_id_${myid.rect_id}-swiperContent_id_${pageContent.swiperContent_id}-elementInSwiperId_${elementOptions.elementInSwiperId}`"
      :data-elementInSwiperId="'element is:' + elementOptions.elementInSwiperId"
      :parentW="getParentW"
      :parentH="getParentH"
      :options="elementOptions"
      :w="elementOptions.width"
      :h="elementOptions.height"
      :x="Number(elementOptions.left)"
      :y="Number(elementOptions.top)"
      :uid="null"
      :parent="true"
      :zoom="zoom"
      :elementInLayoutId="elementOptions.elementInSwiperId"
      :elementName="elementOptions.innerElement"
      :active="elementOptions.isActive"
      :isShowModuleHandles="false"
      v-on:dragging="draggingEv"
      v-on:resizeStop="resizestopEv"
      v-on:dragStop="dragstopEv"
      v-on:activated="activeEv"
      v-on:deactivated="deactive"
      v-on:delElement="delElementEv"
      @refLineParams="getRefLineParams"
      @click.stop.prevent
      @mouseup.stop.prevent
      @mousedown.stop.prevent
      :resizable="checkResizable(elementOptions)"
      :handles="checkHandles(elementOptions)"
      :myId="
        Object.assign(
          { ...myid },
          { swiperContent_id: pageContent.swiperContent_id, elementInSwiperId: elementOptions.elementInSwiperId }
        )
      "
    >
      <component
        style="height: 100%"
        class="rect"
        :myid="{
          rect_id: myid.rect_id,
          container_id: myid.id,
          swiperContent_id: pageContent.swiperContent_id,
          elementInSwiperId: elementOptions.elementInSwiperId
        }"
        :is="elementOptions.innerElement"
        :options="elementOptions"
      />
    </vueDragResizable>
    <!--辅助线-->
    <span
      class="ref-line v-line"
      v-for="item in vLine"
      :key="item.id"
      v-show="item.display"
      :style="{
        left: item.position,
        top: item.origin,
        height: item.lineLength
      }"
    >
    </span>
    <span
      class="ref-line h-line"
      v-for="item in hLine"
      :key="item.id"
      v-show="item.display"
      :style="{
        top: item.position,
        left: item.origin,
        width: item.lineLength
      }"
    >
    </span>
  </div>
</template>

<script>
import animateMixin from "utils/event/animateMixin.js"
import componentsMixin from "./componentsMixin"
export default {
  mixins: [componentsMixin, animateMixin],
  props: {
    swiperContent_id: {
      type: Number,
      required: true,
      default: 0
    },
    zoom: {
      type: Number,
      default: 1
    },
    myid: {
      type: Object
    },
    swiperContent: {
      type: Array
    }
  },
  data() {
    return {
      stageWidth: null,
      stageHeight: null,
      getParentW: null,
      getParentH: null,
      tempEl: null,
      vLine: [],
      hLine: []
    }
  },
  watch: {
    pageContent: {
      deep: true,
      handler(n, o) {
        if (this.$el.offsetWidth !== 0) this.getParentW = this.$el.offsetWidth
        if (this.$el.offsetHeight !== 0) this.getParentH = this.$el.offsetHeight
      }
    }
  },
  computed: {
    pageContent() {
      return this.swiperContent[this.swiperContent_id]
    },
    myContentId() {
      return { ...this.myid, swiperContent_id: this.pageContent.swiperContent_id }
    },
    swiperMode() {
      return this.$store.state.states.swiperMode
    },
    ids() {
      return this.$store.state.states.activeID
    },
    getSwiperBoxStyle() {
      const opt = this.getRectAttribute.call(this, this.myid).options
      const { slidesPerView, direction, width, height } = opt
      const reverseDirection = opt.autoplay.reverseDirection
      this.$emit("updateFillFlexType", direction)
      let position
      switch (direction) {
        case "horizontal":
          // 左右
          if (reverseDirection) {
            position = "left"
          } else {
            position = "right"
          }
          break
        case "vertical":
          this.$emit("updateFillFlexType", direction)
          if (reverseDirection) {
            position = "top"
          } else {
            position = "bottom"
          }
          // 上下
          break
        default:
          break
      }
      if ("topbottom".includes(position)) {
        // 上下模式 用height
        return {
          height: (height - (slidesPerView - 1) * 26) / slidesPerView + "px"
        }
      } else {
        return {
          width: (width - (slidesPerView - 1) * 26) / slidesPerView + "px"
        }
      }
    }
  },
  mounted() {
    this.initVDRParentSize()
  },
  methods: {
    handleClickSwiperColEv() {
      const clearActive = {
        ...this.myContentId,
        elementInSwiperId: null
      }
      const changeActiveID = {
        container_id: this.myContentId.container_id,
        rect_id: this.myContentId.rect_id,
        swiperContent_id: this.pageContent.swiperContent_id
      }
      if (this.pageContent.elementOptions.length) {
        this.$store.dispatch(this.request_prefix + "/changeElementInSwiperActive", clearActive)
      }
      if (Object.keys(changeActiveID).some(k => changeActiveID[k] !== this.ids[k])) {
        this.$store.commit("states/changeElementType", "swiperComponent")
        this.$store.commit("states/changeActiveID", changeActiveID)
      }
    },
    async initVDRParentSize() {
      if (this.$el.offsetWidth !== 0) this.getParentW = this.$el.offsetWidth
      if (this.$el.offsetHeight !== 0) this.getParentH = this.$el.offsetHeight
    },
    draggingEv() {
      if (this.drageLock) {
        this.drageLock = false
        this.initVDRParentSize()
      }
    },
    resizestopEv(rect, elementInSwiperId, uid, direction) {
      const ids = { ...this.myContentId, elementInSwiperId }
      const content_name = ["width", "height"]
      const val = [rect.width, rect.height]
      this.$changeOptionsEV(val, content_name, false, null, ids, true)
    },
    dragstopEv(rect, elementInSwiperId, uid) {
      this.drageLock = true
      const ids = { ...this.myContentId, elementInSwiperId }
      const content_name = ["left", "top"]
      const val = [rect.left, rect.top]
      this.$changeOptionsEV(val, content_name, false, null, ids, true)
    },
    activeEv(elementInSwiperId, index, shape) {
      this.initVDRParentSize()
      const changeId = {
        ...this.myContentId,
        elementInSwiperId
      }
      this.$store.commit("states/changeActiveID", changeId)
      this.$store.commit("states/changeElementType", shape)
      if (!this.$getOptions(changeId).isActive) this.$store.dispatch(this.request_prefix + "/setActive", changeId)
      this.$store.dispatch(this.request_prefix + "/changeElementInSwiperActive", changeId)
    },
    deactive() {},
    delElementEv(args, elementInSwiperId, uid) {
      const delId = {
        ...this.myContentId,
        elementInSwiperId
      }
      this.$store.commit("states/changeElementType", "swiperComponent")
      if (this.$store.state.states.toolBarStatus) this.$store.commit("states/changeToolBarStatus", false)
      this.$store.dispatch(this.request_prefix + "/delComponentInSwiper", delId)
    },
    handleColsDragover(e, id) {
      let attribute = e.dataTransfer.getData("rectAttribute")
      if (attribute) {
        attribute = JSON.parse(attribute)
        //禁止往轮播组件里拖入自由布局组件
        if (attribute.shape.toLowerCase().includes("layout")) return
        //获取当前鼠标的left和top
        let [left, top] = [e.offsetX, e.offsetY]
        ;[attribute.options.left, attribute.options.top] = [left, top]
        attribute.options.isActive = false
        attribute.options.filedMapping = {
          value: null,
          label: null,
          flag: false,
          checked: true
        }
        let param = {
          ...this.myContentId,
          elementOptions: attribute.options
        }
        this.$store.dispatch(this.request_prefix + "/addComponentInSwiper", param)
      }
    },

    // 辅助线回调事件
    getRefLineParams(params) {
      const { vLine, hLine } = params
      let id = 0
      this.vLine = vLine.map(item => {
        item["id"] = ++id
        return item
      })
      this.hLine = hLine.map(item => {
        item["id"] = ++id
        return item
      })
    },
    checkResizable(rect) {
      let widthType = rect.hasOwnProperty("widthType") ? rect.widthType : "px"
      let heightType = rect.hasOwnProperty("heightType") ? rect.heightType : "px"
      if (widthType !== "px" && heightType !== "px") {
        return false
      }
      return rect.resizable
    },
    checkHandles(rect) {
      let widthType = rect.hasOwnProperty("widthType") ? rect.widthType : "px"
      let heightType = rect.hasOwnProperty("heightType") ? rect.heightType : "px"
      if (widthType !== "px" && heightType !== "px") {
        return []
      }
      if (widthType === "px" && heightType !== "px") {
        return ["ml", "mr"]
      }
      if (widthType !== "px" && heightType === "px") {
        return ["tm", "bm"]
      }
      return ["tl", "tm", "tr", "mr", "br", "bm", "bl", "ml"]
    }
  }
}
</script>

<style scoped>
.componentBox {
  width: 100%;
  height: 100%;
  position: relative;
}
.side_change {
  top: calc(50% - 25px);
  position: absolute;
  width: 50px;
  height: 50px;
  border: 1px solid gray;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  border-radius: 50%;
  color: var(--themeColor);
}
.side_change:hover {
  color: black;
  background-color: var(--themeColor);
}
.side_change.prev {
  left: 10px;
}
.side_change.next {
  right: 10px;
}
.pagination {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 50%;
  bottom: 2px;
}
.ref-line {
  position: absolute;
  background-color: rgb(255, 0, 204);
  z-index: 9999;
}

.v-line {
  width: 1px;
}

.h-line {
  height: 1px;
}
</style>
